import React from 'react';
import PolicyPage from '../Policies/PolicyPage';
import cookiesEPrivacidade from '../Policies/content/cookiesEPrivacidade';

/**
 * /privacidade publica a Politica de Cookies e Privacidade de 22/07/2026, que e
 * o documento vigente. O texto antigo (Politica de Privacidade de 10/10/2025,
 * que vivia em PrivacyContent.jsx) foi substituido: tinha 6 direitos do titular
 * contra os 12 do documento aprovado e nao tratava de cookies como documento
 * unico.
 */
const Privacy = () => (
    <PolicyPage
        titulo="Política de Cookies e Privacidade da Empiria"
        versao="Versão publicada em 22 de julho de 2026"
        blocos={cookiesEPrivacidade}
    />
);

export default Privacy;
